

    <ng-container >
        <mat-form-field appearance="outline">
            <mat-label translate
            >{{label}}     <span *ngIf="required(control)" style="color: red">*</span></mat-label
            >

            <mat-select disableOptionCentering #select [formControl]="control" [multiple]="muliple" (selectionChange)="change($event) " >
                
                <ng-container *ngIf="withfiltre"  >
                    <mat-select-filter *ngIf="select.focused"
                            (filteredReturn)="listsearch = $event"
                            [array]="list"
                            [displayMember]="'motcle'"
                            [noResultsMessage]="'empty_list' | translate"
                            [placeholder]="'search' | translate"
                            [showSpinner]="true"
                    >

                    </mat-select-filter>


                </ng-container>


                <ng-container *ngIf="select.focused && getlang()==='fr'"  >
                    <mat-option  *ngFor="let c of listsearch" [value]="c">
                        
                        {{c}}
                    </mat-option>
                    


                </ng-container>
                <ng-container *ngIf="select.focused && getlang()==='ar'"  >
                    <mat-option  *ngFor="let c of listsearch" [value]="c">
                        
                        {{c | translate}}
                    </mat-option>
                 

                </ng-container>

                <ng-container  *ngIf="!select.focused && getlang()==='fr'" >
                    <mat-option *ngFor="let c of list" [value]="c">
                        {{c}}
                    </mat-option>


                </ng-container>
                <ng-container  *ngIf="!select.focused && getlang()==='ar'" >
                    <mat-option *ngFor="let c of list" [value]="c">
                        {{c | translate}}
                    </mat-option>


                </ng-container>
            </mat-select>
            <mat-error [control]="control" appControlError></mat-error>
            <button
                    (click)="clear($event)"
                    *ngIf="control.value"
                    aria-label="Clear"
                    mat-button
                    mat-icon-button
                    matSuffix
                    type="button"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>


    </ng-container>



